module.exports = __webpack_public_path__ + "img/instagram.5ffe3e02.png";